module.exports = __webpack_public_path__ + "static/img/catLogo.821307a1.png";